import { render } from "./TrendData.vue?vue&type=template&id=1b9f52ad&scoped=true"
import script from "./TrendData.vue?vue&type=script&lang=js"
export * from "./TrendData.vue?vue&type=script&lang=js"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9f52ad"]])

export default __exports__